import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface AudioTestActiveStyles {
  container: ICSSInJSStyle;
  header: ICSSInJSStyle;
  description: ICSSInJSStyle;
  testStartPrompt: ICSSInJSStyle;
  cancelButton: ICSSInJSStyle;
  centerAudioButtonSection: ICSSInJSStyle;
}
export const useAudioTestActiveStyles: () => AudioTestActiveStyles = () => {
  const { white, brand, main } = useFluentColorScheme();
  const { isMobile } = usePlatformTypeContext();

  if (isMobile) {
    return {
      container: {
        height: "100%",
        minHeight: "600px",
        width: "100%",
        backgroundColor: main.background2,
        position: "absolute",
        overflow: "scroll",
      },
      header: {
        color: white.foreground,
      },
      description: {
        color: white.foreground,
      },
      centerAudioButtonSection: {
        height: "100%",
      },
      testStartPrompt: {
        color: white.foreground,
        width: "102px",
        height: "24px",
        top: "calc(50% + 150px)",
        left: "calc(50% - 50px)",
        position: "absolute",
      },
      cancelButton: {
        color: white.foreground,
        borderRadius: "4px",
        border: `1px solid ${brand.border}`,
        backgroundColor: "transparent",
      },
    };
  } else {
    return {
      container: {
        width: "100%",
        height: "100%",
        backgroundColor: main.background,
        overflow: "hidden",
      },
      header: {
        color: white.foreground,
        maxWidth: "500px",
        position: "absolute",
        top: "calc(144px - 60px)",
      },
      description: {
        color: white.foreground,
        maxWidth: "500px",
        top: "calc(192px - 48px)",
        position: "absolute",
      },
      centerAudioButtonSection: {
        height: "100%",
      },
      testStartPrompt: {
        color: white.foreground,
        width: "102px",
        height: "24px",
        bottom: "120px",
        left: "calc(380px - 50px)",
        position: "absolute",
      },
      cancelButton: {
        color: white.foreground,
        borderRadius: "4px",
        border: `1px solid ${brand.border}`,
        backgroundColor: "transparent",
      },
    };
  }
};
